
/* eslint-disable */
/*
 * @Descripttion: 
 * @version: 
 * @Author: susj
 * @Date: 2020-09-17 17:18:53
 * @LastEditors: susj
 * @LastEditTime: 2020-11-25 11:42:39
 */

import { message } from 'ant-design-vue';
import { swapArray } from '../../utils/element';
import Page from '../../components/core/models/page';
import Element from '../../components/core/models/element';
import pageApi from '@/services/modules/page'
import asyncData2pageData from '@/utils/page.js'
// actions
export const actions = {
  setEditingPageIndex({ commit }, pageIndex = 0) {
    commit('setEditingPageIndex', pageIndex);
  },
  setEditingPage({ commit }, pageIndex = 0) {
    commit('setEditingPage', pageIndex);
  },
  async pageManager({ dispatch, commit, state }, { type, value }) {
    // commit('pageManager', payload);
    const { editingPage } = state;
    const curPage = value ? state.work.pages[value.pageIndex] : null
    switch (type) {
      case 'add':
        const pageIndexNext=value.pageIndex+1
        const resAdd = await pageApi.slideWrapCreate({
          pptId: state.work.id,
          sort: pageIndexNext,
          slideType: value.slideType
        })
        if (resAdd && resAdd.success) {
          const pageDate = asyncData2pageData(resAdd.result)
          value = { ...value, ...pageDate }
          commit('pageManager', { type, value });
          commit('setEditingPage',pageIndexNext);
          // 重新排序一下
          dispatch('pageManager', { type: 'resetAll' });
          // 如果是空间详情页，需默认新增一个空间名变量
          value.slideType===1&&dispatch('elementManager',{
            type: 'add',
            value: {
              name: 'ppt-text-template',
              shortcutProps: {
                contentType: 'roomName',
                contentName: '空间名',
                areaType: 'roomName',
                textStyle: `<p><span style="color: #333; font-size: 30px; font-weight: bold;">%s</span></p>`
              },
              box: {
                width: state.work.width,
                height: state.work.height,
              },
              commonStyle: {
                width: 226,
                height: 48,
                top:0,
                left:0
              }
            },
          })
        }
        break;
      case 'copy':
        const pageIndexNextCopy=value.pageIndex+1
        const resCopy = await pageApi.slideWrapCopySlide({
          pptId: state.work.id,
          id: state.work.pages[value.pageIndex].uuid,
          sort: value.pageIndex + 1,
        })
        if (resCopy && resCopy.success) {
          const pageDate = asyncData2pageData(resCopy.result)
          value = { ...value, ...pageDate }
          commit('pageManager', { type, value });
          commit('setEditingPage',pageIndexNextCopy);
          dispatch('pageManager', { type: 'resetAll' })//删除成功之后，重新排序 ；因为删除本地数据已经排序，所以不需要做本地排序，只需要异步排序
        }
        break;
      case 'delete':
        const res = await pageApi.slideWrapDelSlide({
          pptId: curPage.pptId,
          id: curPage.uuid,
        })
        res.success && commit('pageManager', { type: 'delete', value });
        res.success && dispatch('pageManager', { type: 'resetAll' })//删除成功之后，重新排序 ；因为删除本地数据已经排序，所以不需要做本地排序，只需要异步排序
        break;
      default:
        commit('pageManager', { type: type, value });
        const slideResults = [];
        const pages = JSON.parse(JSON.stringify(state.work.pages));
        pages.forEach((item, index) => {
          slideResults.push({
            id: item.uuid,
            sort: index + 1,
          });
        });
        await pageApi.slideWrapSlideSort({
          pptId: state.editingPage.pptId,
          slideId: state.editingPage.uuid,
          slideResults
        })
    }
  },
};

// mutations
export const mutations = {
  setEditingPageIndex(state, pageIndex = 0) {
    state.editingPageIndex = pageIndex;
  },
  setEditingPage(state, pageIndex = 0) {
    state.editingPage = state.work.pages[pageIndex];
  },
  pageManager(state, { type, value = {} }) {
    const { editingPage, work } = state;
    const {
      pages,
      pageIndex = 0,
      pageIndexForEditingTitle,
      newTitle,
    } = value;
    const pageLength = work.pages.length;
    const slideType = work.pages[pageIndex].slideType || 0;
    const moveItem = (targetIndex) => {
      if(slideType===1 && work.isTemplate>0) {
        let roomPage = work.pages.filter(item=>item.slideType===1)
        let normalPage = work.pages.filter(item=>item.slideType===0)
        work.pages = type==='move2Top'?[...roomPage,...normalPage]:[...normalPage,...roomPage]
      } else {
        const item = work.pages.splice(pageIndex, 1);
        work.pages.splice(targetIndex, 0, item[0]);
      }
    }
    switch (type) {
      case 'editTitle':
        work.pages[pageIndexForEditingTitle].title = newTitle;
        break;
      case 'add':
        value.elements = value.elements.map(element => new Element(element));
        work.pages.splice(pageIndex + 1, 0, new Page(value));
        break;
      case 'copy':
        value.elements = value.elements.map(element => new Element(element));
        work.pages.splice(pageIndex + 1, 0, new Page(value));
        // work.pages.push(work.pages[pageIndex].clone());
        break;
      case 'delete':
        if (pageLength === 1) {
          // #!zh: 至少需要保留一个页面
          // #!en: At least one page needs to be kept in the work
          message.info('至少需要保留一个页面');
          return;
        }
        work.pages.splice(pageIndex, 1);
        break;
      case 'move2Top':
        moveItem(0);
        break;
      case 'move2Bottom':
        moveItem(pageLength - 1);
        break;
      case 'updatePages':
        if (pages) {
          work.pages = pages;
        }
        break;
    }
  },
};
